<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="TIT"><img alt="" height="800" src="images/title.jpg" width="533"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?0e0c749d